import { NotificationData, PushNotificationService } from './../../services/notification/push-notification.service';
import { NotificationFactoryService } from './../../services/notification/notification-factory.service';
import { MessageService } from 'primeng/api';
import { MyInstituteService } from './../../services/institute/myinstitute/my-institute.service';
import { Store } from '@ngxs/store';
import { Component, OnInit } from '@angular/core';
import { TopNavBarComponent } from '../student-portal-layout/top-nav-bar/top-nav-bar.component';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { AuthService } from '../../services/account/auth.service';
import { UpdateUser } from '../../states/user/user-action';
import { SetMyAddedInstitute } from '../../states/myInstitutes/my-institute-actions';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { SignalRService } from '../../services/signal-r/signal-r.service';
import { ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AuthRoles, AuthRolesFromString } from '../../models/enums/enums';
import { jwtDecode } from 'jwt-decode';
import { LoadPortalMenus } from '../../states/menu/menu.actions';
import { OnboardingModalComponent } from '../../shared/components/onboarding-modal/onboarding-modal.component';

// import { LoadPortalMenus } from '../../states/menu/menu.actions';
@Component({
  selector: 'app-student-portal-layout',
  standalone: true,
  imports: [RouterOutlet, TopNavBarComponent, ToastModule, AvatarModule, ButtonModule, RouterModule, CommonModule, OnboardingModalComponent],
  templateUrl: './student-portal-layout.component.html',
  styleUrl: './student-portal-layout.component.scss',
})
export class StudentPortalLayoutComponent implements OnInit {
  constructor(
    private authService: AuthService, private store: Store, private myInstituteService: MyInstituteService,
    private signalRService: SignalRService, private messageService: MessageService, private notificationFactoryService: NotificationFactoryService,
    private pushNotificationService: PushNotificationService,
    private route: Router
  ) {
  }
  ngOnInit(): void {
    this.store.dispatch(new LoadPortalMenus());
    this.getUser();
    this.getMyInstitutes();
    this.setSignalRConnection();
    this.getNotification();
    this.observeNotification();
  }

  onReject(){

  }
  onConfirm(){

  }

  observeNotification() {
    this.pushNotificationService.notification$.subscribe({
      next: (notification: NotificationData) => {
        this.messageService.add(
          {
            key: 'notification',
            sticky: true,
            severity: 'success',
            summary: notification.message,
            data: {
              name: notification.name, image: notification.image,
              route: notification.route
            },
          }
        );
      },
      error: (error) => {
        console.warn('Error fetching notification');
      }
    });
  }

  getNotification() {
    this.signalRService.hubNotification.subscribe({
      next: (response) => {
        var notificationService = this.notificationFactoryService.getNotificationService(response.messageTemplate);
        notificationService.notify(response.message,response.data);
      },
      error: (error) => {
        console.warn('Error fetching notification');
      },
    });
  }

  setSignalRConnection() {
    this.signalRService.initiateSignalrConnection().then(() => {
    }).catch(() => {
      console.warn('SignalR Connection failed');
    });
  }

  getUser() {
    var accountData = localStorage.getItem("account");
    if (accountData) {
      // Parse the JSON string into an object
      const account = JSON.parse(accountData);
      const roles = this.getRoles(account.token);
      this.authService.getUserByid(account.userId).subscribe({
        next: (user) => {
          this.store.dispatch(new UpdateUser({
            id: user.id,
            email: user.email,
            phoneNumber: user.phoneNumber,
            firstName: user.firstName,
            lastName: user.lastName,
            role: roles,
            isNewUser: account.isNewUser,
            profileImageUrl: account.profileImageUrl,
            personalInfoState: user.personalInfoState,
            profileImageFormat: account.profileImageFormat,
            degreePreference: account.degreePreference
          }))
        },
        error: () => {
        }
      });
    }
  }

  private getRoles(token: string): AuthRoles[]{
    if (!token) return [];
    try{
      const decodedToken: any = jwtDecode(token);
      let roles = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || [];
      if( typeof roles === 'string'){
        roles = [roles];
      }else if(!Array.isArray(roles)){
        roles = [];
      }
      return roles.map((role: string) => AuthRolesFromString[role]);
    }catch(error){
      console.error('Invalid Token', error);
      return [];
    }
  }

  getMyInstitutes() {
    this.myInstituteService.getMyInstitutes().subscribe({
      next: (response: Institute[]) => {
        this.store.dispatch(new SetMyAddedInstitute({ items: response }));
      },
      error: (error) => {
        console.log('Error fetching institutes');
      },
      complete: () => {
        console.log('Institute fetching completed');
      }
    });
  }

  showConfirm() {
    this.messageService.add(
      {
        key: 'notification',
        sticky: true,
        severity: 'success',
        summary: 'Can you send me the report?',
        data: {
          name: 'Amy Elsner', image: 'assets/images/default-profile.png',
          route: '/student-portal/notification'
        },
      }
    );
  }

  openNotification(route: string) {
    this.messageService.clear('notification');
    this.route.navigate([route]);
  }
}

